import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import classNames from 'classnames';
import { SPACINGS } from '../../utils';
import { ActionText } from '../../typography';
import { ActionType, LinkInternalType, LinkExternalType } from '../../types';

const SideMenuStyled = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${SPACINGS[2]} 0;
    padding-left: ${SPACINGS[3]};
    border-left: 2px solid transparent;
    padding-right: 10px;

    &.active {
      border-left: 2px solid ${(p) => p.theme.colors.black};
      border-left: 2px solid ${(p) => p.theme.colors.primary};
      background-color: ${(p) => p.theme.colors.primary95w};
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    &:hover {
      border-left: 2px solid ${(p) => p.theme.colors.black80w};
      border-left: 2px solid ${(p) => p.theme.colors.primary80w};
    }
  }
`;

type SideMenuProps = {
  items: ({
    label: string;
    active: boolean;
    icon?: React.ReactNode;
    style?: React.CSSProperties;
  } & (ActionType | LinkInternalType | LinkExternalType))[];
  style?: React.CSSProperties;
};
function SideMenu(props: SideMenuProps) {
  const { items, style } = props;
  const theme = useTheme();
  const itemStyle = { marginTop: SPACINGS[1], marginBottom: SPACINGS[1] };

  return (
    <SideMenuStyled style={style}>
      {items.map((item) => {
        const classes = classNames({
          item: true,
          active: item.active,
        });

        const style = item.style ? { ...item.style, ...itemStyle } : itemStyle;
        return (
          <li key={item.label} className={classes}>
            <ActionText
              {...item}
              style={{...style, ...{color: item.active ? theme.colors.primary : theme.colors.secondary}}}
              transform="none"
              weight={item.active ? 'normal' : 'light'}
              margin="none"
            >
              {item.label}
            </ActionText>
            {item.icon}
          </li>
        );
      })}
    </SideMenuStyled>
  );
}

export default SideMenu;
